import { css } from 'aphrodite';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { IMeetingConfigLanding } from '../../../extViewmodels';
import { CustomPageType } from '../../../extViewmodels/sdk/models/CustomPageStyle';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { baseStyleSheet } from '../../../web/styles/styles';
import { IMeetingLandingCard, MeetingLandingBody } from '../../components/MeetingLandingBody';
import { styleSheet } from '../../components/MeetingLandingBody/styles';
import { useLanding } from '../../contexts/landing';
import { useCustomPageStyle } from '../../hooks/useCustomPageStyle';
import { ScheduleMeetingNotFound } from '../../ScheduleMeetingNotFound';
import { styleSheet as pageStyles } from '../../styles/styles';
import { MeetingContainer } from '../MeetingContainer';

export const ScheduleMeetingLanding: React.FC = () => {
	const { landingVm } = useLanding();
	const location = useLocation();
	const history = useHistory();

	const { hasCustomContent: hasCustomHeader } = useCustomPageStyle(landingVm.shortCode, CustomPageType.Header);
	const { hasCustomContent: hasCustomFooter } = useCustomPageStyle(landingVm.shortCode, CustomPageType.Footer);

	const [landing, setLanding] = React.useState<IMeetingConfigLanding>(null);
	const [isLoading, setIsLoading] = React.useState(false);
	const [hasError, setHasError] = React.useState(false);

	React.useEffect(() => {
		setIsLoading(true);
		landingVm
			.fetchMeetings()
			.then(value => {
				setLanding(value);
			})
			.catch(() => {
				setHasError(true);
			})
			.finally(() => {
				setIsLoading(false);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onBookMeeting = (meeting: IMeetingLandingCard) => {
		const path = location?.search
			? `/${meeting.shortCode}/${meeting.vanityPath}${location.search}`
			: `/${meeting.shortCode}/${meeting.vanityPath}`;
		history.push(path);
	};

	const hasCustomHeaderOrFooter = hasCustomHeader || hasCustomFooter;

	return (
		<MeetingContainer shortCode={landingVm.shortCode}>
			{isLoading || hasError || !landing?.meetingConfigs?.length ? (
				<div
					className={css(
						styleSheet.mainContainer,
						pageStyles.sharedBackgroundWrapper,
						hasCustomHeaderOrFooter && pageStyles.sharedBackgroundWrapperMobileNoCustom
					)}
				>
					<div className={css(styleSheet.contentContainer)}>
						{isLoading ? (
							<LoadingSpinner className={css(baseStyleSheet.absoluteCenter)} />
						) : (
							<ScheduleMeetingNotFound text={hasError ? 'Invalid Meeting URL' : 'No meetings found'} />
						)}
					</div>
				</div>
			) : (
				<MeetingLandingBody
					companyName={landing.companyName}
					creatorName={landing.creatorName}
					hasCustomHeaderOrFooter={hasCustomHeaderOrFooter}
					meetingConfigs={landing.meetingConfigs}
					onBookMeeting={onBookMeeting}
				/>
			)}
		</MeetingContainer>
	);
};
